import { useQuery } from '@tanstack/react-query';

import { FILTER_VIEWS_KEY } from './constants';
import { getFilterViews } from './filterViews';

/**
 * Hook to fetch all filter views for a page
 */
export const useGetFilterViews = (pageIdentifier: string) => {
  return useQuery({
    queryKey: [FILTER_VIEWS_KEY, pageIdentifier],
    queryFn: () => getFilterViews(pageIdentifier),
    enabled: !!pageIdentifier,
  });
};
